import React, { useEffect, useState } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useSelector } from "react-redux";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { get_all_executives } from "../../endpoints/API";
import { message } from "antd";

const containerStyle = {
  width: "100%",
  height: "90vh",
};

const center = {
  lat: 20.5937,
  lng: 78.9629,
};

const WETracking = () => {
  const [executives, setExecutives] = useState([]);

  useEffect(() => {
    const fetchExecutives = async () => {
      try {
        const response = await get_all_executives();
        setExecutives(response?.data || []);
      } catch (error) {
        message.error(
          error?.response?.data?.error || "Failed to fetch executives"
        );
      }
    };

    fetchExecutives();
  }, []);

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={5}>
      {executives?.map(exec => (
        <Marker
          key={exec.id}
          position={{ lat: exec.lat, lng: exec.long }}
          label={`${exec.first_name}${exec.middle_name}${exec.last_name}`}
        />
      ))}
    </GoogleMap>
  );
};

export default WETracking;
